// extracted by mini-css-extract-plugin
export var blue = "_1b-h";
export var brand = "_1b-d";
export var darkGrey = "_1b-g";
export var disabled = "_1b-6";
export var disabledSubtle = "_1b-7";
export var error = "_1b-8";
export var green = "_1b-i";
export var grey = "_1b-f";
export var icon = "_1b-0";
export var inherit = "_1b-c";
export var lightGrey = "_1b-e";
export var orange = "_1b-k";
export var pink = "_1b-m";
export var primary = "_1b-1";
export var purple = "_1b-n";
export var quaternary = "_1b-4";
export var quinary = "_1b-5";
export var red = "_1b-l";
export var secondary = "_1b-2";
export var success = "_1b-b";
export var tertiary = "_1b-3";
export var warning = "_1b-9";
export var warningSecondary = "_1b-a";
export var white = "_1b-o";
export var yellow = "_1b-j";